import { CreateMedicineDosagePackageTypePayload } from 'src/interfaces/medicine';
import { sageItemCodeForApi } from './sage-item-code';

/** Map the package-type form to the create/edit API body. */
export function toPackageTypeApiPayload(formValue: {
  containedQuantity: number;
  packageType: { id: number };
  labelName: string;
  price: number;
  unitsPerPack?: number | string | null;
  minOrderQty?: number | string | null;
  sageItemCode?: string | null;
}): CreateMedicineDosagePackageTypePayload {
  const units = Number(formValue.unitsPerPack);
  const minRaw = formValue.minOrderQty;
  const minNum = minRaw === '' || minRaw == null ? NaN : Number(minRaw);
  return {
    contained_quantity: formValue.containedQuantity,
    package_type_id: formValue.packageType.id,
    label_name: formValue.labelName,
    price: formValue.price,
    units_per_pack: Number.isFinite(units) && units >= 1 ? Math.floor(units) : 1,
    min_order_qty: Number.isFinite(minNum) && minNum >= 1 ? Math.floor(minNum) : null,
    // Item code only. Do not send sage_item_id; a changed code clears that id on the server.
    sage_item_code: sageItemCodeForApi(formValue.sageItemCode),
  };
}
